import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface ScopeDifferentialRateDto {
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  differentialRate: number;
}
